<template>
  <div id="matchPurchaseContract">
    <span @click="handleOpen">
      <slot></slot>
    </span>
    <el-dialog
      :title="this.$t('matchPurchaseContract.dialogTitle')"
      :visible.sync="dialogVisible"
      fullscreen
      @close="close"
    >
      <sirui-search
        v-if="searchColumns.length && dialogVisible"
        ref="siruiSearch"
        :query="query"
        :columns="searchColumns"
        :colSpan="8"
        :buttonSpan="5"
        @resetBtnClick="resetBtnClick"
        @searchBtnClick="search"
      ></sirui-search>
      <div class="main-content">
        <vxe-toolbar custom>
          <template v-slot:buttons>
            <span>选中{{ multipleSelection.length }}条</span>
            <vxe-input
              type="float"
              size="small"
              digits="6"
              v-model="initForm.initTotalAmount"
              placeholder="搜索"
            ></vxe-input>
            <vxe-button status="primary" @click="setTotalAmout">分配总金额</vxe-button>
            <vxe-button type="primary" @click="exportDetail">导出</vxe-button>
          </template>
        </vxe-toolbar>
        <vxe-table
          ref="siruiTable"
          border
          resizable
          size="mini"
          :custom-config="{ storage: true }"
          :loading="load"
          :data="tableData"
          :edit-rules="validRules"
          :edit-config="{ trigger: 'click', mode: 'cell' }"
          :checkbox-config="{ reserve: reserve }"
          row-id="id"
          :tooltip-config="{ theme: 'light' }"
          show-footer
          :height="tableHeight"
          :footer-method="footerMethod"
          :sort-config="{ remote: true, orders: ['asc', 'desc'] }"
          @select-change="handleSelectionChange"
          @select-all="handleSelectionChange"
          @sort-change="handleSortChange"
        >
          <vxe-table-column type="checkbox" width="50" fixed="left"></vxe-table-column>
          <vxe-table-column
            v-for="(item, index) in columnList"
            :key="index"
            :field="item.prop"
            :width="item.width || columnWidth"
            v-bind="item"
          >
            <template v-slot:edit="scope">
              <el-input-number
                v-if="item.editRender.name == 'input'"
                v-model="scope.row[item.prop]"
                :controls="false"
                class="inputWidth"
                :min="-9999999999999"
                :max="99999999999999"
                :disabled="filterDisabled(scope.row, item.prop)"
                @input="(e) => handleChange(scope.row, item.prop)"
              ></el-input-number>
              <!--数字输入框--显示2位-->
              <inputNumberAd
                v-model="scope.row[item.prop]"
                v-if="item.editRender.name == 'amountRound'"
                :controls="false"
                class="inputWidth"
                :clearable="true"
                :disabled="filterDisabled(scope.row, item.prop)"
                :precision="item.editRender.attrs.precision"
                :min="-99999999999999999"
                :max="99999999999999999"
                @input="(e) => handleChange(scope.row, item.prop)"
              ></inputNumberAd>
              <el-select
                v-else-if="item.editRender.name == 'select'"
                filterable
                clearable
                v-model="scope.row[item.prop]"
                @change="(e) => handleChange(scope.row, item.prop)"
              >
                <el-option
                  v-for="(i, index) in item.editRender.options"
                  :key="index"
                  :label="i.label"
                  :value="i.value"
                ></el-option>
              </el-select>
            </template>
            <template v-slot="{ row }">
              <span v-if="item.editRender && item.editRender.name == 'select'">{{
                getSelectLabel(row[item.prop], item.editRender.options)
              }}</span>
              <span v-else-if="item.format">
                {{ row[item.prop] | formatTableColumn(item.format) }}
              </span>
              <span v-else>{{ row[item.prop] }}</span>
            </template>
          </vxe-table-column>
        </vxe-table>
        <el-pagination
          ref="page"
          background
          @size-change="handleSizeChange"
          @current-change="handlePagination"
          :page-count="page.pages"
          :current-page="page.pageNum || 1"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="page.pageSize"
          :total="page.total"
          layout="total, sizes, prev, pager, next, jumper"
        ></el-pagination>
      </div>
      <div slot="footer" ref="footer" class="dialog-footer">
        <el-button @click="close">{{ $t('dialog.cancel') }}</el-button>
        <el-button type="primary" @click="handleConfirm">{{ $t('dialog.confirm') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  // import SelectTableDialog from '@/components/SelectTableDialog';
  import SiruiSearch from '@/components/SiruiSearch';
  // import SiruiTable from '@/components/SiruiTable';
  // import COMPANY_API from '@/api/masterData/company';
  // import BASEAPI from '@/api/dataBase.js';
  import { mapState } from 'vuex';
  import API from '@/api/financeCenter/payables';
  import { filterEmpty, toLine, delcommafy } from '@/common/js/util';
  import InputNumberAd from '@/components/form-item/input-number-advance';
  import XEUtils from 'xe-utils';
  import baseUrl from '@/common/config';
  export default {
    props: {
      data: {
        type: Object,
        default: () => {},
      },
      feeInfo: {
        type: Object,
        default: () => {},
      },
      contractData: {
        type: Object,
        default: () => {},
      },
      taxRateList: {
        type: Array,
        default: () => [],
      },
      fromContract: {
        type: Boolean,
        default: () => false,
      },
      differenceInvoiceFlag: {
        type: Boolean,
        default: () => false,
      },
    },

    components: {
      // SelectTableDialog,
      SiruiSearch,
      // SiruiTable,
      InputNumberAd,
    },
    data() {
      return {
        reserve: true,
        initForm: { initTotalAmount: 0 },
        defaultVisible: false,
        API: API.LIST_BUSINESS_INBOUNDS,
        query: {},
        dialogVisible: false,
        load: false,
        tableData: [],
        multipleSelection: [],
        curCheckedKeys: this.checkRowKeys,
        page: {
          pages: 1, //总共多少页
          pageNum: 1, //第几页
          pageSize: 50, //一页多少条数据
          total: 0, //总共多少条
        },
        tableHeight: 0,
      };
    },
    watch: {
      defaultVisible() {
        if (this.defaultVisible) {
          this.handleOpen();
        }
        this.dialogVisible = this.defaultVisible;
      },
      checkRowKeys(newValue) {
        this.curCheckedKeys = newValue;
      },
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
        // 商品单位
        unitList() {
          return this.$baseRequest.getDictListMapByType('basic_unit');
        },
      }),
      isCargoType() {
        return this.contractData.expenseType === 'CGHK';
        // return XEUtils.isEmpty(this.contractData) ? false  : this.contractData[0].expenseType === 'CGHK'
      },
      //搜索字段
      searchColumns() {
        const invoiceUnitName = this.feeInfo && this.feeInfo.invoiceUnitName;
        const columns = [
          {
            type: 'searchTableSpec',
            name: this.$t('matchPurchaseContract.search.supplier'),
            prop: 'partner',
            searchType: 'supplier',
            extraData: {
              companyCode: this.feeInfo.payableInvoiceCompanyCode,
              departmentCode: this.data.payableInvoiceDepartmentCode,
            },
            isMultiple: true,
            currentValue: this.isCargoType && invoiceUnitName ? invoiceUnitName : null,
            disabled: this.isCargoType,
          },
          {
            prop: 'contractNo',
            name: this.$t('matchPurchaseContract.search.contractNo'),
            type: 'input',
            placeholder: this.$t('matchPurchaseContract.search.contractNo'),
            disabled: this.fromContract,
          },
          {
            prop: 'externalContractNo',
            name: this.$t('matchPurchaseContract.search.externalContractNo'),
            type: 'input',
            placeholder: this.$t(
              'matchPurchaseContract.search.externalPurchaseContractNoPlaceholder'
            ),
          },
          {
            prop: 'businessInboundBatchNoLike',
            name: this.$t('matchPurchaseContract.search.settleBatchNumber'),
            type: 'input',
            placeholder: this.$t('matchPurchaseContract.search.warehousingBatchNoPlaceholder'),
          },
          {
            prop: 'inboundDateStart',
            name: this.$t('matchPurchaseContract.search.warehousingDateStart'),
            type: 'startDaterangePicker',
          },
          {
            prop: 'inboundDateEnd',
            name: this.$t('matchPurchaseContract.search.warehousingDateEnd'),
            type: 'endDaterangePicker',
          },
          {
            prop: 'businessInboundNo',
            name: this.$t('matchPurchaseContract.search.businessInboundNo'),
            type: 'input',
            placeholder: this.$t('matchPurchaseContract.search.contractNo'),
          },
          {
            prop: 'productDesc',
            name: '商品描述',
            type: 'input',
            placeholder: '请输入商品描述',
          },
        ];
        return columns;
      },
      //表格显示字段
      columnList() {
        const columnList = [
          {
            prop: 'contractNo',
            label: this.$t('matchPurchaseContract.table.contractNo'),
            width: 120,
          },
          {
            prop: 'contractDetailNo',
            label: this.$t('matchPurchaseContract.table.contractDetailNo'),
            width: 120,
          },
          {
            prop: 'businessInboundBatchNo',
            label: this.$t('matchPurchaseContract.table.businessInboundBatchNo'),
            width: 120,
          },
          {
            prop: 'businessInboundNo',
            label: this.$t('matchPurchaseContract.table.businessInboundNo'),
            width: 120,
          },
          {
            prop: 'inboundDate',
            label: this.$t('matchPurchaseContract.table.inboundCreateDate'),
            width: 120,
          },
          {
            prop: 'productDesc',
            label: this.$t('matchPurchaseContract.table.productDesc'),
            width: 120,
          },
          {
            prop: 'productUnit',
            label: this.$t('matchPurchaseContract.table.productUnit'),
            width: 120,
            editRender: { name: 'select', label: 'label', value: 'value', options: this.unitList },
          },
          {
            prop: 'inboundQuantity',
            label: this.$t('matchPurchaseContract.table.inboundQuantity'),
            width: 120,
          },
          {
            prop: 'businessVariablePriceWithoutTax',
            label: this.$t('matchPurchaseContract.table.inboundUnitPrice'),
            width: 120,
          },
          {
            prop: 'exchangeRate',
            label: this.$t('matchPurchaseContract.table.exchangeRate'),
            width: 120,
          },
          {
            prop: 'matchedQuantity',
            label: this.$t('matchPurchaseContract.table.matchedQuantity'),
            width: 120,
          },
          {
            prop: 'matchAvailableQuantity',
            label: this.$t('matchPurchaseContract.table.matchedAavailableQuantity'),
            width: 120,
            sortable: true,
          },
          {
            prop: 'matchInboundQuantity',
            label: this.$t('matchPurchaseContract.table.matchInboundQuantity'),
            width: 120,
            editRender: {
              name: 'amountRound',
              attrs: { type: 'number', precision: this.$globalVar.qPoint, clearable: true },
            },
          },
          {
            prop: 'overShippedQuantity',
            label: this.$t('matchPurchaseContract.table.overShippedQuantity'),
            width: 120,
            editRender: {
              name: 'amountRound',
              attrs: { type: 'number', precision: this.$globalVar.qPoint, clearable: true },
            },
          },
          {
            prop: 'invoiceQuantity',
            label: this.$t('matchPurchaseContract.table.invoiceQuantity'),
            width: 120,
            render: (value, row) =>
              this.$cal.calCommon(
                row.matchInboundQuantity || 0,
                row.overShippedQuantity || 0,
                '+',
                'quantity'
              ),
          },
          {
            prop: 'invoiceUnitPrice',
            label: this.$t('matchPurchaseContract.table.invoiceUnitPrice'),
            width: 120,
            format: 'formatQuality',
          },
          {
            prop: 'invoiceUnitPriceWithTax',
            label: this.$t('addInvoice.invoiceLine.table.invoiceUnitPriceWithTax'),
            width: 120,
            format: 'formatQuality',
          },
          {
            prop: 'originalTotalWithoutTaxAmount',
            label: this.$t('matchPurchaseContract.table.originalTotalWithoutTaxAmount'),
            width: 120,
            format: 'formatAmountRound',
          },
          {
            prop: 'taxCode',
            label: this.$t('matchPurchaseContract.table.taxCode'),
            width: 220,
            editRender: {
              name: 'select',
              label: 'label',
              value: 'value',
              options: this.taxRateList,
            },
          },
          { prop: 'taxRate', label: this.$t('matchPurchaseContract.table.taxRate'), width: 120 },
          {
            prop: 'taxAmount',
            label: this.$t('matchPurchaseContract.table.taxAmount'),
            width: 120,
            editRender: { name: 'amountRound', attrs: { type: 'number' } },
            format: 'formatAmountRound',
          },
          {
            prop: 'totalAmount',
            label: this.$t('matchPurchaseContract.table.totalAmount'),
            width: 120,
            editRender: { name: 'amountRound', attrs: { type: 'number' } },
            format: 'formatAmountRound',
          },
        ];
        return columnList;
      },

      //校验
      validRules() {
        const matchInboundQuantityValid = (rule, value, callback, { row }) => {
          //匹配入库数量≤可匹配数量
          if (this.contractData.expenseType == 'CGHK') {
            if (Math.abs(value) > Math.abs(row.matchAvailableQuantity || 0)) {
              callback(new Error('可匹配数量不能超过匹配入库数量'));
            } else {
              if (row.returnNo) {
                value <= 0 ? callback() : callback(new Error('退货单匹配入库数量需小于等于0'));
              } else {
                value >= 0 ? callback() : callback(new Error('入库单匹配入库数量需大于等于0'));
              }
            }
          } else {
            callback();
          }
        };

        const originalTotalWithoutTaxAmountValid = (rule, value, callback, { row }) => {
          if (this.feeInfo.invoiceType == 'invoice') {
            // 蓝票走原有逻辑
            if (row.returnNo) {
              value < 0 ? callback() : callback(new Error('退货单不含税金额需小于0'));
            } else {
              value > 0 ? callback() : callback(new Error('入库单不含税金额需大于0'));
            }
          } else {
            // 红票 当“本次匹配入库数量”为0的时候放开后面对金额的限制，可以填负数
            if (row.returnNo) {
              value < 0 ? callback() : callback(new Error('退货单不含税金额需小于0'));
            } else {
              callback();
            }
          }
        };

        const valid = {
          // taxAmount:[
          //   { required: true, message: 'app.body.valid.rName' },
          // ],
          matchInboundQuantity: [
            {
              required: this.contractData.expenseType == 'CGHK',
              message: this.$t('matchPurchaseContract.table.matchInboundQuantity'),
            },
            { validator: matchInboundQuantityValid },
          ],
          taxRate: [{ required: true, message: this.$t('matchPurchaseContract.table.taxRate') }],
          taxCode: [{ required: true, message: this.$t('matchPurchaseContract.table.taxCode') }],
          taxAmount: [
            { required: true, message: this.$t('addInvoice.invoiceLine.table.taxAmount') },
          ],
          totalAmount: [
            { required: true, message: this.$t('addInvoice.invoiceLine.table.totalAmount') },
          ],
          originalTotalWithoutTaxAmount: [
            {
              required: true,
              message: this.$t('matchPurchaseContract.table.originalTotalWithoutTaxAmount'),
            },
            { validator: originalTotalWithoutTaxAmountValid },
          ],
        };
        if (this.isCargoType) {
          valid['matchInboundQuantity'] = [
            {
              required: true,
              min: 0,
              max: 10,
              message: this.$t('matchPurchaseContract.table.matchInboundQuantity'),
            },
            { validator: matchInboundQuantityValid },
          ];
          /* valid['overShippedQuantity']=[
          { required: true, message: this.$t("matchPurchaseContract.table.overShippedQuantity") },
        ] */
        }
        return valid;
      },
    },
    methods: {
      resetTableHeight() {
        let searchHeight = this.$refs.siruiSearch.$el.offsetHeight;
        let footerH = this.$refs.footer.offsetHeight;
        this.tableHeight = document.body.clientHeight - searchHeight - footerH - 300 + 'px' || 0;
        // this.tableHeight = '300px'
      },
      setTotalAmout() {
        let initTotalAmount = delcommafy(this.initForm.initTotalAmount);
        let tableInfo = this.$refs.siruiTable.getTableData();
        let invoiceQuantityCol = null;
        if (!this.isCargoType) {
          // 非采购货款 分摊已入库数量
          invoiceQuantityCol = this.$refs.siruiTable.getColumnByField('inboundQuantity');
        } else {
          // 采购货款 分摊收票数量
          invoiceQuantityCol = this.$refs.siruiTable.getColumnByField('invoiceQuantity');
        }
        let invoiceQuantityIndex = this.$refs.siruiTable.getColumnIndex(invoiceQuantityCol);
        let invoiceQuantityTotal = tableInfo.footerData[0][invoiceQuantityIndex]; //收票数量列
        let invoicePrice = this.$cal.calCommon(initTotalAmount, invoiceQuantityTotal, '/', 'price');
        let checkedTable = this.$refs.siruiTable.getCheckboxRecords();
        //采购货款-- 根据收票数量分配
        if (this.isCargoType) {
          for (let i = 0; i < checkedTable.length; i++) {
            let row = checkedTable[i];
            // 发票含税单价
            row['invoiceUnitPriceWithTax'] = invoicePrice;
            // 总额 = 发票含税单价*本次收票数量
            row['totalAmount'] = this.$cal.calCommon(
              row['invoiceUnitPriceWithTax'],
              row['invoiceQuantity'],
              '*',
              'amount'
            );
            // 不含税金额 = 总额/（1+税率）
            row['originalTotalWithoutTaxAmount'] = this.$cal.calCommon(
              row['totalAmount'],
              this.$cal.calCommon(1, row['taxRate'], '+'),
              '/',
              'amount'
            );
            // 发票单价 = 不含税金额/本次收票数量
            row['invoiceUnitPrice'] = this.$cal.calCommon(
              row['originalTotalWithoutTaxAmount'],
              row['invoiceQuantity'],
              '/',
              'price'
            );
            // 税额=总额-不含税金额
            row['taxAmount'] = this.$cal.calCommon(
              row['totalAmount'],
              row['originalTotalWithoutTaxAmount'] || 0,
              '-',
              'amount'
            );
          }
        } else {
          //ID1000776 成本类的费用（关税、港杂费等）需要根据填写含税总金额，根据已入库数量平摊金额到【总额】
          for (let j = 0; j < checkedTable.length; j++) {
            let row = checkedTable[j];
            // 总额 = 发票含税单价*本次收票数量
            row['totalAmount'] = this.$cal.calCommon(
              invoicePrice,
              row['inboundQuantity'],
              '*',
              'amount'
            );
            // 不含税金额 = 总额/（1+税率）
            row['originalTotalWithoutTaxAmount'] = this.$cal.calCommon(
              row['totalAmount'],
              this.$cal.calCommon(1, row['taxRate'], '+'),
              '/',
              'amount'
            );
            // 税额=总额-不含税金额
            row['taxAmount'] = this.$cal.calCommon(
              row['totalAmount'],
              row['originalTotalWithoutTaxAmount'] || 0,
              '-',
              'amount'
            );
          }
        }
        this.$refs.siruiTable.updateFooter();
      },
      handleOpen() {
        this.$nextTick(() => {
          this.resetBtnClick();
          this.resetTableHeight();
        });
      },
      getSelectLabel(value, list, valueProp = 'value', labelField = 'label') {
        let item = XEUtils.find(list, (item) => item[valueProp] === value);
        return item ? item[labelField] : null;
      },
      handleSortChange(order) {
        if (!order) return;
        this.query.orderBy = order == 'asc' ? '1' : '2';
        this.getData();
      },
      getData() {
        if (!this.API) return;
        this.API = API.LIST_BUSINESS_INBOUNDS;
        if (this.fromContract) this.query.contractNo = this.contractData.purchaseContractNo;
        const query = this.getQuery();
        /* if (search && Object.keys(query).length == 2) {
        this.$message({
          showClose: true,
          message: this.$t("search.nosearchError"),
          type: "error"
        });
        return;
      } */
        if (query.partner) {
          query.partnerNo = query.partner[0].partnerCode;
          delete query.partner;
        } else {
          if (this.isCargoType) query.partnerNo = this.feeInfo.invoiceUnitNo;
        }
        const params = Object.assign({}, this.extraData, query);
        params.tenantCode = this.userInfo.tenantCode;
        params['inboundCompanyNo'] = this.feeInfo.payableInvoiceCompanyCode;
        params['inboundDepartmentNo'] =
          this.feeInfo.isHnFlag == 'N' ? this.contractData.payableInvoiceDepartmentCode : '';
        params['currencyTypeCode'] = this.isCargoType ? this.feeInfo.currencyCode : '';
        params['inboundStatus'] = '02'; //业务确认状态
        // isGreaterThanZero  // 2 已入库数量inboundQuantity>0
        if (this.feeInfo.invoiceType == 'invoice') {
          params['mQGreaterThanZero'] = '1'; // 1 可匹配数量matchAvailableQuantity!=0
          params['isLessThanZero'] = '1'; //  2 已入库数量inboundQuantity<0
        } else {
          // params['isLessThanZero'] = 2
          params['isCreditMemo'] = '1'; // 判断是否
        }

        this.load = true;
        this.$axios
          .post(this.API, params)
          .then((res) => {
            this.load = false;
            if (0 == res.data.code) {
              res.data.data.list.forEach((i) => {
                let returnFlag = i.returnNo; //退换货标志 有退换货号
                // i.inboundQuantity = i.inboundQuantity;
                // i.matchAvailableQuantity = !returnFlag?i.matchAvailableQuantity:i.matchAvailableQuantity*-1
                // i.matchedQuantity = i.matchedQuantity;
                i.originalTotalWithoutTaxAmount = !returnFlag
                  ? i.businessVariablePricePureAmount
                  : i.businessVariablePricePureAmount * -1;
                i.matchInboundQuantity = i.matchAvailableQuantity;
                if (i.matchInboundQuantity) {
                  i.invoiceQuantity = this.$cal.calCommon(
                    i.matchInboundQuantity || 0,
                    i.overShippedQuantity || 0,
                    '+',
                    'quantity'
                  );
                  i.invoiceUnitPrice = this.$cal.calCommon(
                    i['originalTotalWithoutTaxAmount'],
                    i['invoiceQuantity'],
                    '/',
                    'quantity'
                  );
                }

                if (!this.isCargoType) {
                  i.taxCode = '';
                  i.taxRate = '';
                  i.originalTotalWithoutTaxAmount = '';
                  i.matchInboundQuantity = '';
                  i.invoiceQuantity = '';
                  i.invoiceUnitPrice = '';
                }
                i['taxAmount'] = this.$cal.calCommon(
                  i.taxRate,
                  i.originalTotalWithoutTaxAmount || 0,
                  '*',
                  'amount'
                );
                //总额 = 不含税金额+税额
                i['totalAmount'] = this.$cal.calCommon(
                  i.taxAmount,
                  i.originalTotalWithoutTaxAmount || 0,
                  '+',
                  'amount'
                );
                // 发票含税单价 = 总额/本次收票数量
                i['invoiceUnitPriceWithTax'] = this.$cal.calCommon(
                  i['totalAmount'],
                  i['invoiceQuantity'],
                  '/',
                  'price'
                );
              });
              this.tableData = res.data.data.list;
              const list = res.data.data.list.map((m) => m.businessInboundBatchNo);
              const index = list.indexOf(this.data.inboundBatchNo);
              if (this.data.inboundBatchNo) {
                this.tableData[index] = {
                  ...this.tableData[index],
                  overShippedQuantity: this.contractData.overShippedQuantity || 0,
                  invoiceUnitPrice: this.contractData.invoiceUnitPrice || 0,
                  originalTotalWithoutTaxAmount: this.contractData.amountWithoutTax || 0,
                  taxRate: this.contractData.taxRate || 0,
                  taxAmount: this.contractData.taxAmount || 0,
                  totalAmount: this.contractData.totalAmount || 0,
                  taxCode: this.contractData.taxCode,
                  matchInboundQuantity: this.contractData.matchInboundQuantity,
                  invoiceQuantity: this.contractData.invoiceQuantity,
                };
              }

              this.page.total = res.data.data.total;
              this.$refs.siruiTable.setCheckboxRow(this.tableData[index], true);
              this.multipleSelection = this.tableData[index];
              this.$refs.siruiTable.updateFooter();
              this.$refs.siruiTable.reloadTable(res.data.data.list);
            } else {
              this.tableData = [];
              this.page.total = 0;
              // this.$refs.siruiTable.reloadTable([]);
              // this.$refs.siruiTable.setPageTotal(0);
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error',
              });
            }
          })
          .catch(() => {
            this.load = false;
          });
      },
      handleChange(row, field) {
        // 本次收票数量 = 本次匹配入库数量+溢短装数量
        row['invoiceQuantity'] = this.$cal.calCommon(
          row.overShippedQuantity || 0,
          row.matchInboundQuantity || 0,
          '+',
          'quantity'
        );
        if (field == 'taxCode') {
          row['taxRate'] = this.taxRateList.find((it) => it.taxCode == row.taxCode).taxRate;
          // 税额 = 含税总额*税率(错的)  = 含税金额/(1+税率）*税率
          let step1 = this.$cal.calCommon(1, row['taxRate'], '+');
          let step2 = this.$cal.calCommon(row['totalAmount'], step1, '/');
          row['taxAmount'] = this.$cal.calCommon(step2, row['taxRate'], '*', 'amount');
          // 不含税金额=总额-税额
          row['originalTotalWithoutTaxAmount'] = this.$cal.calCommon(
            row['totalAmount'],
            row['taxAmount'] || 0,
            '-',
            'amount'
          );
        }
        /* if(field=="matchInboundQuantity"){
        row['originalTotalWithoutTaxAmount'] = this.$cal.calCommon(row["invoiceUnitPrice"],row["invoiceQuantity"],"*","amount")
      } */

        // const {
        //   taxRate,
        //   originalTotalWithoutTaxAmount,
        //   overShippedQuantity,
        //   matchInboundQuantity,
        // } = row;
        if (field == 'taxAmount') {
          // 不含税金额=总额-税额
          row['originalTotalWithoutTaxAmount'] = this.$cal.calCommon(
            row['totalAmount'],
            row['taxAmount'] || 0,
            '-',
            'amount'
          );
        }
        if (field == 'originalTotalWithoutTaxAmount') {
          // 税额=总额-不含税金额
          row['taxAmount'] = this.$cal.calCommon(
            row['totalAmount'],
            row['originalTotalWithoutTaxAmount'] || 0,
            '-',
            'amount'
          );
        }
        if (field == 'totalAmount') {
          // 不含税金额 = 总额/（1+税率）
          row['originalTotalWithoutTaxAmount'] = this.$cal.calCommon(
            row['totalAmount'],
            this.$cal.calCommon(1, row['taxRate'], '+'),
            '/',
            'amount'
          );
          // 税额=总额-不含税金额
          row['taxAmount'] = this.$cal.calCommon(
            row['totalAmount'],
            row['originalTotalWithoutTaxAmount'] || 0,
            '-',
            'amount'
          );
        }
        // 发票含税单价 = 总额/本次收票数量
        row['invoiceUnitPriceWithTax'] = this.$cal.calCommon(
          row['totalAmount'],
          row['invoiceQuantity'],
          '/',
          'price'
        );
        // 发票单价 = 不含税金额/本次收票数量
        row['invoiceUnitPrice'] = this.$cal.calCommon(
          row['originalTotalWithoutTaxAmount'],
          row['invoiceQuantity'],
          '/',
          'price'
        );

        this.$refs.siruiTable.updateFooter();
      },

      // 弹窗确认
      handleConfirm() {
        let selectRecords = this.$refs.siruiTable.getCheckboxRecords();
        if (selectRecords.length < 1) {
          this.$message({
            showClose: true,
            message: this.$t('xTable.noSelectData'),
            type: 'error',
          });
          return;
        }
        console.log(selectRecords);
        // this.$refs.siruiTable.validate(selectRecords).then(valid => {
        //     this.$emit('selectContract', selectRecords[0])
        // }).catch(()=>{
        //     this.$XModal.message({ status: 'error', message: this.$t('message.validateFalse') })
        // })
        this.$refs.siruiTable.validate(selectRecords, (valid) => {
          if (valid) {
            // this.$emit('selectContract', selectRecords[0])
            // 判罚是否为差额发票 并且入库数量0和非0不能同时存在
            // 【ID1002539】 发票区分差额发票 如果有采购货款并且可匹配数量为0的 则认定为差额发票。所有行也必须为采购货款且可匹配数量为0
            this.checkDifferenceInvoice(selectRecords);
          } else {
            this.$message({
              showClose: true,
              message: '校验不通过！',
              type: 'error',
            });
          }
        });
      },
      // 判罚是否为差额发票 并且入库数量0和非0不能同时存在
      // 【ID1002539】 发票区分差额发票 如果有采购货款并且可匹配数量为0的 则认定为差额发票。所有行也必须为采购货款且可匹配数量为0
      checkDifferenceInvoice(selectRecords) {
        let valid = true;
        let msg = '';
        if (this.differenceInvoiceFlag) {
          let flag = selectRecords.findIndex((item) => item.matchAvailableQuantity != 0);
          valid = flag == -1;
          msg = '差额发票只能选择可匹配数量为0的入库单';
        } else {
          let diffArr = [];
          let noDiffArr = [];
          selectRecords.map((item) => {
            if (item.matchAvailableQuantity == 0) {
              diffArr.push(item.id);
            } else {
              noDiffArr.push(item.id);
            }
          });
          if (diffArr[0] && noDiffArr[0]) {
            valid = false;
            msg = '可匹配数量为0的入库单和非0的入库单不能同时开票';
          }
        }
        if (valid) {
          this.$emit('selectContract', selectRecords);
        } else {
          this.$message({
            showClose: true,
            message: msg,
            type: 'error',
          });
        }
      },
      // 弹窗关闭
      close() {
        this.defaultVisible = false;
      },
      // 重置
      resetBtnClick() {
        this.query = {};
        this.page.pageNum = 1;
        this.page.pageSize = 50;
        if (this.$refs.siruiTable) {
          this.$refs.siruiTable.clearCheckboxReserve();
          this.$refs.siruiTable.clearCheckboxRow();
        }
        this.multipleSelection = [];
        this.$refs.siruiTable.clearCheckboxReserve();
        this.getData();
      },
      // 搜索
      search() {
        this.page.pageNum = 1;
        this.$refs.siruiTable.clearCheckboxReserve();
        this.multipleSelection = [];
        this.getData(true);
      },
      // 表格排序
      sortChangeEvent({ property, order }) {
        let orderByDesc = '';
        if (order) {
          orderByDesc = `${toLine(property)} ${order}`;
        }
        const query = Object.assign({}, this.query, {
          orderByDesc,
        });
        this.query = query;
        this.getData();
      },
      // 获取查询参数
      getQuery() {
        // 分页数据
        const { pageNum, pageSize } = this.page;
        const query = this.query;
        const result = Object.assign({}, query, {
          pageNum,
          pageSize,
        });
        this.searchColumns.forEach((item) => {
          if (item.getSearchCode) {
            const arr = query[item.prop];
            if (arr && arr.length) {
              const codes = arr.map((code) => {
                return code[item.getSearchCode];
              });
              // 单选改第一个，多选给多个
              result[item.prop] = item.isMultiple ? codes[0] : codes;
            }
          }
        });
        return filterEmpty(result);
      },
      // 点击分页
      handlePagination(val) {
        this.page.pageNum = val;
        this.getData();
      },
      // 分页条数改变
      handleSizeChange(val) {
        this.page.pageNum = 1;
        this.page.pageSize = val;
        this.getData();
      },
      // 表格选中行
      handleSelectionChange(val) {
        // 当允许翻页时，勾选checkbox需要将历史记录合并
        this.multipleSelection =
          this.$refs.siruiTable.getCheckboxReserveRecords()[0] && this.reserve
            ? this.$refs.siruiTable.getCheckboxReserveRecords().concat(val.selection)
            : val.selection;
        this.$refs.siruiTable.updateFooter();
      },
      //禁止编辑
      filterDisabled(row, filed) {
        const arr = ['matchInboundQuantity', 'overShippedQuantity', 'invoiceUnitPrice'];
        // const arr1 = ['originalTotalWithoutTaxAmount', 'taxRate', 'taxAmount'];

        if (!this.isCargoType && arr.indexOf(filed) > -1) {
          //其他类型 本次匹配数量、溢短装数量、发票单价
          return true;
        }
      },
      //设置总条数
      setPageTotal(val) {
        this.page.total = val;
      },
      //设置页数为第一页
      setPageNum(val) {
        this.page.pageNum = val;
      },
      //设置每页显示10条
      setPageSize(val) {
        this.page.pageSize = val;
      },
      footerMethod({ columns }) {
        return [
          columns.map((column, columnIndex) => {
            if (columnIndex === 0) {
              return this.$t('xTable.total');
            }
            let arr = this.$refs.siruiTable.getCheckboxRecords();
            if (['originalTotalWithoutTaxAmount'].includes(column.property)) {
              return arr
                .map((i) => i['originalTotalWithoutTaxAmount'])
                .reduce((acc, cur) => {
                  let num = this.$cal.calCommon(delcommafy(acc), delcommafy(cur), '+');
                  return this.$baseRequest.formatTableColumn(num);
                }, 0);
            }
            if (['taxAmount'].includes(column.property)) {
              let total = arr
                .map((i) => i['taxAmount'])
                .reduce((acc, cur) => {
                  let num = this.$cal.calCommon(acc, cur, '+');
                  return num;
                }, 0);
              return this.$baseRequest.formatTableColumn(total);
            }
            if (['totalAmount'].includes(column.property)) {
              let total = arr
                .map((i) => i['totalAmount'])
                .reduce((acc, cur) => {
                  let num = this.$cal.calCommon(acc, cur, '+');
                  return num;
                }, 0);
              return this.$baseRequest.formatTableColumn(total);
            }
            if (['matchedQuantity'].includes(column.property)) {
              let total = arr
                .map((i) => i['matchedQuantity'])
                .reduce((acc, cur) => {
                  let num = this.$cal.calCommon(acc, cur, '+');
                  return num;
                }, 0);
              return this.$baseRequest.formatTableColumnForNum(total);
            }
            if (['matchInboundQuantity'].includes(column.property)) {
              let total = arr
                .map((i) => i['matchInboundQuantity'])
                .reduce((acc, cur) => {
                  let num = this.$cal.calCommon(acc, cur, '+');
                  return num;
                }, 0);
              return this.$baseRequest.formatTableColumnForNum(total);
            }
            if (['overShippedQuantity'].includes(column.property)) {
              let total = arr
                .map((i) => i['overShippedQuantity'])
                .reduce((acc, cur) => {
                  let num = this.$cal.calCommon(acc, cur, '+');
                  return num;
                }, 0);
              return this.$baseRequest.formatTableColumnForNum(total);
            }
            if (['invoiceQuantity'].includes(column.property)) {
              let total = arr
                .map((i) => i['invoiceQuantity'])
                .reduce((acc, cur) => {
                  let num = this.$cal.calCommon(acc, cur, '+');
                  return num;
                }, 0);
              return this.$baseRequest.formatTableColumnForNum(total);
            }
            if (['inboundQuantity'].includes(column.property)) {
              let total = arr
                .map((i) => i['inboundQuantity'])
                .reduce((acc, cur) => {
                  let num = this.$cal.calCommon(acc, cur, '+');
                  return num;
                }, 0);
              return this.$baseRequest.formatTableColumnForNum(total);
            }

            return null;
          }),
        ];
      },

      // 导出
      exportDetail() {
        const selectedList = this.multipleSelection; // 历史选中数据
        if (selectedList.length == 0) {
          this.$message({
            showClose: true,
            message: '请选择需要导出的数据',
            type: 'success',
          });
        }
        let str = '';
        selectedList.forEach((item) => {
          str += 'ids=' + item.id + '&';
        });
        window.location.href = `${baseUrl}${API.EXPORT_BUSINESS_INBOUNDS}?${str}access_token=${this.userInfo.access_token}`;
      },
    },
  };
</script>
<style lang="scss">
  #matchPurchaseContract .el-dialog__body {
    max-height: calc(80vh) !important;
  }
  #matchPurchaseContract .el-pagination {
    text-align: right;
    padding-top: 10px;
    margin-bottom: 8px;
  }
</style>
